export default __webpack_public_path__ + "81aac68.png";